import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export async function getActiveCustomers(limit = 2000, lastEvaluatedKey = null) {
  try {
    const params = {
      limit: limit,
      lastEvaluatedKey: lastEvaluatedKey
    };

    const response = await axios.post(
      `${API_URL}/customermaster/getactivecustomers`,
      params
    );
    
    return response.data;
  } catch (error) {
    console.log("error => ", error);
    return { items: [], lastEvaluatedKey: null };
  }
}
